const base = {
  logo: "Login to access your Account",
  fields: {
    username: {
      info: "",
      label: "Username",
      required: "The field cannot be empty",
      placeholder: "your@email.com"
    },
    password: {
      info: "Password must contain at least 6 characters",
      label: "Password",
      required: "The field cannot be empty",
      placeholder: "Your password"
    },
    uid: {
      info: "",
      label: "UID",
      required: "The field cannot be empty",
      placeholder: "AAA-AA-AAAAA"
    },
    rememberMe: "Remember me"
  },
  login: {
    label: "Login",
    tooltip: ""
  },
  companyKey: {
    label: (key) => `Company Key: ${key}`,
    notYourCompanyKey: "Not your company key?"
  },
  sso: {
    label: "WorkWave Sign In",
    tooltip: ""
  },
  divider: "or",
  gracePeriod: {
    title: (gracePeriod, gracePeriodUnit) => {
      const plural = gracePeriod > 1 ? "s" : "";
      return `Expiring in ${gracePeriod} ${gracePeriodUnit}${plural}`;
    },
    message: "Configure your WorkWave Sign in to retain access"
  }
};
function getDefaultTexts(texts) {
  const loginLogo = texts?.logo;
  const loginUserName = texts?.fields?.username;
  const loginPassword = texts?.fields?.password;
  const loginUID = texts?.fields?.uid;
  const loginRemember = texts?.fields?.rememberMe;
  const loginBtn = texts?.login;
  const companyKey = texts?.companyKey;
  const sso = texts?.sso;
  const divider = texts?.divider;
  const gracePeriod = texts?.gracePeriod;
  return {
    logo: loginLogo ?? base.logo,
    fields: {
      username: {
        info: loginUserName?.info ?? base.fields.username.info,
        label: loginUserName?.label ?? base.fields.username.label,
        required: loginUserName?.required ?? base.fields.username.required,
        placeholder: loginUserName?.placeholder ?? base.fields.username.placeholder
      },
      password: {
        info: loginPassword?.info ?? base.fields.password.info,
        label: loginPassword?.label ?? base.fields.password.label,
        required: loginPassword?.required ?? base.fields.password.required,
        placeholder: loginPassword?.placeholder ?? base.fields.password.placeholder
      },
      uid: {
        info: loginUID?.info ?? base.fields.uid.info,
        label: loginUID?.label ?? base.fields.uid.label,
        required: loginUID?.required ?? base.fields.uid.required,
        placeholder: loginUID?.placeholder ?? base.fields.uid.placeholder
      },
      rememberMe: loginRemember ?? base.fields.rememberMe
    },
    login: {
      label: loginBtn?.label ?? base.login.label,
      tooltip: loginBtn?.tooltip ?? base.login.tooltip
    },
    companyKey: {
      label: companyKey?.label ?? base.companyKey.label,
      notYourCompanyKey: companyKey?.notYourCompanyKey ?? base.companyKey.notYourCompanyKey
    },
    sso: {
      label: sso?.label ?? base.sso.label,
      tooltip: sso?.tooltip ?? base.sso.tooltip
    },
    divider: divider ?? base.divider,
    gracePeriod: {
      title: gracePeriod?.title ?? base.gracePeriod.title,
      message: gracePeriod?.message ?? base.gracePeriod.message
    }
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
